'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LogInForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _forms = require('common/components/forms');

var _reactReduxForm = require('react-redux-form');

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _qs = require('qs');

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _reactRedux = require('react-redux');

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _googleLoginOrSignup = require('./google-login-or-signup');

var _googleLoginOrSignup2 = _interopRequireDefault(_googleLoginOrSignup);

var _loginCaptcha = require('./login-captcha');

var _loginCaptcha2 = _interopRequireDefault(_loginCaptcha);

require('./log-in-form.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import GoogleSigninButton   from './google-signin-button';


var FORM_NAME = 'logIn';

var LogInForm = exports.LogInForm = function (_Component) {
    _inherits(LogInForm, _Component);

    function LogInForm(props) {
        _classCallCheck(this, LogInForm);

        var _this = _possibleConstructorReturn(this, (LogInForm.__proto__ || Object.getPrototypeOf(LogInForm)).call(this, props));

        _this.state = {
            displayCaptcha: _this.props.displayCaptcha
        };

        _this.handleGeneralError = _this.handleGeneralError.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleResponse = _this.handleResponse.bind(_this);
        return _this;
    }

    /**
     * Handles any generic/fallback errors we want to handle
     */


    _createClass(LogInForm, [{
        key: 'handleGeneralError',
        value: function handleGeneralError(error) {
            this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));
        }
    }, {
        key: 'handleResponse',
        value: function handleResponse(err, response) {
            // Error here means some kind of network error (4xx or 5xx)
            if (err) {
                return this.handleGeneralError(err);
            }

            try {
                // Here we can errors back from the server and display errors if
                // necessary
                var resp = response.body;

                // Create notification if backend provided one
                if (resp.notification) {
                    hellofaxJS.createNotification({
                        'text': resp.notification.message,
                        'class_name': resp.notification.type
                    });
                }

                // Handle success and failure
                if (resp.success === true) {
                    this.props.dispatch(_reactReduxForm.actions.setSubmitted(FORM_NAME));

                    // Redirect to on_login_redirect_url
                    if (resp.on_login_redirect_url) {
                        window.location = resp.on_login_redirect_url;
                    }
                } else {
                    this.props.dispatch(_reactReduxForm.actions.setSubmitFailed(FORM_NAME));

                    var hasErrorMsg = !!(resp.error && resp.error.message);

                    if (this.state.displayCaptcha) {
                        // Refresh CAPTCHA
                        grecaptcha.reset();
                    }

                    if (resp.display_captcha) {
                        if (!this.state.displayCaptcha) {
                            // Show CAPTCHA
                            this.setState({
                                'displayCaptcha': true
                            });
                        }
                    } else if (resp.on_error_redirect_url) {
                        // Redirect to on_error_redirect_url
                        window.location = resp.on_error_redirect_url;
                    } else if (hasErrorMsg && !resp.notification_message) {
                        // Show CAPTCHA if backend said to
                        this.setState({
                            'displayCaptcha': resp.display_captcha
                        });

                        // Display error message
                        this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
                            server: resp.error.message
                        }));
                    }
                }

                if (response.error) {
                    this.props.dispatch(_reactReduxForm.actions.setErrors(FORM_NAME, {
                        server: resp.error.message
                    }));
                }
            } catch (e) {
                return this.handleGeneralError(err);
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(values) {
            var _this2 = this;

            var url = _hfReactHelper2['default'].urlHelper('account/logIn', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);

            // Grab recaptcha response if present
            var captcha = document.getElementById('g-recaptcha-response');
            var captcha_response = captcha ? captcha.value : null;

            var data = (0, _qs.stringify)({
                login: {
                    email_address: values.emailAddress,
                    password: values.password,
                    should_remember_me: values.rememberMe,
                    _csrf_token: values.csrfToken,
                    pending_tsm_group_guid: values.pendingTsmGroupGuid,
                    redirect_url: values.redirectUrl
                },
                async: 1,
                'g-recaptcha-response': captcha_response
            });

            return _superagent2['default'].post(url).type('form').send(data).on('request', function () {
                _this2.props.dispatch(_reactReduxForm.actions.setPending(FORM_NAME));
            }).end(this.handleResponse);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var pending = this.props.pending;


            var captcha = this.state.displayCaptcha ? _react2['default'].createElement(
                'div',
                { className: 'l-margin-v-20' },
                _react2['default'].createElement(_loginCaptcha2['default'], { recaptchaPublicKey: this.props.recaptchaPublicKey, tabIndex: 4 })
            ) : null;

            var samlHint = this.props.displaySamlHint ? _react2['default'].createElement(
                'div',
                { className: 'm-log-in-form--saml-label' },
                'To log in via SAML, just enter your email address.'
            ) : null;

            // Old-style Google Signin Button (TODO: Replace with new GoogleSigninButton component)
            var googleLoginImage = _react2['default'].createElement(
                'div',
                { className: 'm-create-account--modal-google-login-border' },
                _react2['default'].createElement('div', { className: 'm-create-account--modal-google-login-or-image' })
            );
            var googleOpenId = _react2['default'].createElement(
                'div',
                { className: 'm-create-account--modal-google-login text-center' },
                this.props.fields ? googleLoginImage : null,
                _react2['default'].createElement(
                    'div',
                    { className: 'm-create-account--modal-google-login-button' },
                    _react2['default'].createElement(_googleLoginOrSignup2['default'], {
                        openIdUrl: this.props.googleOpenIdUrl,
                        isOptedIn: this.props.isOptedIn,
                        isLogIn: true })
                )
            );

            return _react2['default'].createElement(
                'div',
                { className: 'm-log-in-form' },
                googleOpenId,
                _react2['default'].createElement('hr', { className: 'l-margin-v-40' }),
                _react2['default'].createElement(
                    _reactReduxForm.Form,
                    { model: FORM_NAME, onSubmit: this.handleSubmit },
                    _react2['default'].createElement(
                        _forms.Field,
                        { label: 'Email Address' },
                        _react2['default'].createElement(_reactReduxForm.Control.input, {
                            type: 'email',
                            model: 'logIn.emailAddress',
                            validators: { isEmail: _hfReactHelper2['default'].isValidEmailAddress }
                        }),
                        _react2['default'].createElement(_reactReduxForm.Errors, {
                            model: 'logIn.emailAddress',
                            show: 'touched',
                            messages: { isEmail: 'Please enter a valid email address' },
                            className: 'm-field--error'
                        }),
                        samlHint
                    ),
                    _react2['default'].createElement(
                        _forms.Field,
                        { label: 'Password' },
                        _react2['default'].createElement(_reactReduxForm.Control.input, {
                            type: 'password',
                            model: 'logIn.password'
                        }),
                        _react2['default'].createElement(
                            'a',
                            {
                                className: 'm-log-in-form--forgot-password-link',
                                href: '/account/recoverPassword',
                                onClick: function onClick(e) {
                                    // Save email field value to sessionStorage for prefill on the next page
                                    // (Only if emailAddress is not null, since sessionStorage casts that to "null")
                                    if (_this3.props.emailAddress) {
                                        window.sessionStorage['email'] = _this3.props.emailAddress;
                                    }
                                    return true;
                                }
                            },
                            'Forgot password?'
                        )
                    ),
                    captcha,
                    _react2['default'].createElement(
                        'div',
                        { className: 'l-margin-v-20' },
                        _react2['default'].createElement(_reactReduxForm.Errors, {
                            model: FORM_NAME,
                            show: true,
                            className: 'c-blood'
                        })
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-log-in-form--submit-controls row' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-log-in-form--remember-me small-6 columns' },
                            _react2['default'].createElement(
                                'label',
                                null,
                                _react2['default'].createElement(_reactReduxForm.Control.checkbox, { model: 'logIn.rememberMe' }),
                                ' Remember me'
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-log-in-form--submit small-6 columns' },
                            _react2['default'].createElement(_button2['default'], {
                                buttonText: 'Login',
                                buttonColor: 'azure',
                                type: 'submit',
                                disabled: pending
                            })
                        )
                    )
                )
            );
        }
    }]);

    return LogInForm;
}(_react.Component);

LogInForm.propTypes = {
    // Provided from Redux state by connect
    pending: _react2['default'].PropTypes.bool.isRequired,

    // Redux dispatcher object, provided from Redux by connect
    dispatch: _react2['default'].PropTypes.func.isRequired,

    // Needed by the GoogleSigninButton component
    googleSignInClientId: _react2['default'].PropTypes.string.isRequired,

    // Needed by the LogInCaptcha component
    recaptchaPublicKey: _react2['default'].PropTypes.string.isRequired,

    // Decides whether the CAPTCHA should be displayed initially
    displayCaptcha: _react2['default'].PropTypes.bool,

    // Needed by the GoogleLoginOrSignup component
    googleOpenIdUrl: _react2['default'].PropTypes.string.isRequired
};


function mapStateToProps(state) {
    var $form = state.forms.logIn.$form;


    return {
        pending: $form.pending,
        emailAddress: state.logIn.emailAddress
    };
}

exports['default'] = (0, _reactRedux.connect)(mapStateToProps)(LogInForm);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/log-in-form.jsx
 ** module id = 1017
 ** module chunks = 0
 **/